// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").removeClass("is_close");
        $("nav").addClass("is_open");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// スライダー
jQuery(function ($) {
  const swiper = new Swiper(".js-top-slider", {
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 2000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  });
});

// ヘッダー固定
jQuery(function ($) {
	if ( $('.js-header-fixed').length > 0 ) {
		$(window).scroll(function() {
			var fvHeight = $('.js-header-fixed').outerHeight();
			var scrollTop = $(window).scrollTop();
			
			if (scrollTop > fvHeight) {
				$('.l-header').addClass('is-fixed');
			} else {
				$('.l-header').removeClass('is-fixed');
			}
		});
	}
});

// FAQアコーディオン
jQuery(function ($) {
	if ($(".js-ac-toggle").length > 0) {
		$(".js-ac-toggle").on("click", function () {
			var $contents = $(this).siblings(".js-ac-contents");
			$contents.slideToggle(300);
      $(this).toggleClass('is-open');
		});
	}
});


// マイクロモーダル
jQuery(function ($) {
  MicroModal.init({
    disableScroll: true,
    onShow: modal => {
      const scrollArea = modal.querySelector('[data-micromodal-scroll]');
      if (scrollArea) {
        scrollArea.scrollTop = 0;
      }
    }
  });
});


// modal スライダー
jQuery(function ($) {
  $(".modal-slider").each(function () {
    var $modal = $(this).closest(".modal");
    var $thumbnailSlider = $modal.find(".thumbnail-slider");
    if ($thumbnailSlider.length > 0) {
      var thumbnailSlider = new Swiper($thumbnailSlider[0], {
        freeMode: true,
        slidesPerView: 3.2,
        slidesPerGroup: 3.2,
        spaceBetween: 8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        grid: {
          rows: 2,
          fill: 'row',
        },
        breakpoints: {
          769: {
            spaceBetween: 15,
            slidesPerView: 4,
            grid: {
              rows: 1,
              fill: 'row',
            },
          },
        },
  
      });
      var modalSlider = new Swiper(this, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: thumbnailSlider,
        },
      });
    }
  });
});


// 送料セクション Lottieアニメーション
jQuery(function ($) {
  var lottiePath = (typeof sountraTheme !== 'undefined' && sountraTheme.uri) ? sountraTheme.uri + '/map.json' : '';
  if ($('#p-postage-lottie').length > 0 && typeof lottie !== 'undefined' && lottiePath) {
    lottie.loadAnimation({
      container: document.getElementById('p-postage-lottie'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: lottiePath,
    });
  }
});

// タグ
// 要素が画面内に入ったらclass付与
jQuery(function ($) {
  $(window).scroll(function () {
    $('.js-scene-sec').each(function () {
      var hit = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var wHeight = $(window).height();
      var customTop = 450;
      if (hit + customTop < wHeight + scroll) {
        $(this).addClass("is-active");
      }
    });
  });
});
